import { faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import React from "react";
import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  timer: {
    display: "inline-block",
    direction: "rtl",
    fontSize: 10,
    marginTop: 4,
  },
  number: {
    marginRight: 3,
  },
});
const Timer = ({ counter }) => {
  const styles = useStyles();
  return (
    <div className={styles.timer}>
      <FontAwesomeIcon icon={faStopwatch} />
      <span className={styles.number}>"</span>
      <span className={styles.number}>{digitsEnToFa(counter)}</span>
    </div>
  );
};

export { Timer };
